export const userActionTypes = {
    SET_USER: 'SET_USER',
    ACCOUNT_USER: 'ACCOUNT_USER',
    REMOVE_USER: 'REMOVE_USER'
}